module.exports = __webpack_public_path__ + "img/pgd_a_01001.bd667134.png";